import React from "react";
import { useTranslation } from "react-i18next";
import { FaLinkedinIn, FaInstagram, FaTwitter } from "react-icons/fa";
import "../../pages/site/site.scss";

export const FooterComponent = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-site">
      <div className="footer-site-container">
        <div className="footer-site-brand">
          <h2>
            WIZEWINGS
            <sup>TM</sup>
          </h2>
        </div>

        <div className="footer-site-column footer-site-address">
          <h3>{t("footerAddressTitle")}</h3>
          <p>{t("footerAddress")}</p>
        </div>

        <div className="footer-site-column footer-site-contact">
          <h3>{t("footerContactTitle")}</h3>

          <a className="footer-site-phone" href="tel:+19045695688">
            {t("footerPhone")}
          </a>
          <a href="/terms">{t("termsOfUse")}</a>
          <a href="/privacy">{t("privacyPolicy")}</a>
        </div>

        <div className="footer-site-column footer-site-social">
          <h3>{t("footerSocialTitle")}</h3>

          <div className="footer-site-social-icons">
            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://www.instagram.com/wizewings/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
